import {mapGetters} from "vuex";

import breadcrumb from './atoms/breadcrumb/index.vue'

export default {
    name: 'breadcrumbs',
    components: {
        breadcrumb
    },
    computed: {
        ...mapGetters({
            currentItem: 'courses/currentItem',
        }),
        colorBreadcrumb() {
            if (this.$route.name === 'courses-dashboard') {
                if (!this.currentItem) return '#959595'
                return this.currentItem.header.data.colorBreadcrumbs
            } else {
                return '#959595'
            }
        }
    }
}
